// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDEaZ4qsprFHQ9FrynV2x3gtnpgQwXlrNc",
  authDomain: "my-slack-app-e1ddd.firebaseapp.com",
  projectId: "my-slack-app-e1ddd",
  storageBucket: "my-slack-app-e1ddd.firebasestorage.app",
  messagingSenderId: "790902624834",
  appId: "1:790902624834:web:8e05779ee91ab4a6b513db"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);